import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SharedModule} from "../shared/shared.module";
import {AppBreadcrumbModule, AppHeaderModule} from "@coreui/angular";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AuthenticationModule} from "../authentication/authentication.module";
import { HomePageComponent } from './views/home-page/home-page.component';
import { CustomerListComponent } from './views/cooperative/customer-list/customer-list.component';
import { CustomerAddComponent } from './views/cooperative/customer-add/customer-add.component';
import { CustomerFormComponent } from './views/cooperative/customer-add/customer-form/customer-form.component';
import { CooperativeListComponent } from './views/cooperative/cooperative-list/cooperative-list.component';
import { CooperativeAddComponent } from './views/cooperative/cooperative-add/cooperative-add.component';
import { CooperativeInfoComponent } from './views/cooperative/cooperative-add/cooperative-info/cooperative-info.component';
import { MeterDataComponent } from './views/cooperative/meter-data/meter-data.component';
import {CurrentMeterDataComponent} from "./views/cooperative/meter-data/current-meter-data/current-meter-data.component";
import { StationListComponent } from './views/cooperative/station-list/station-list.component';
import { StationAddComponent } from './views/cooperative/station-add/station-add.component';
import { StationInfoComponent } from './views/cooperative/station-add/station-info/station-info.component';
import { PrivacyPolicyComponent } from './views/privacy-policy/privacy-policy.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    CustomerListComponent,
    CustomerAddComponent,
    CustomerFormComponent,
    CooperativeListComponent,
    CooperativeAddComponent,
    CooperativeInfoComponent,
    CurrentMeterDataComponent,
    MeterDataComponent,
    StationListComponent,
    StationAddComponent,
    StationInfoComponent,
    PrivacyPolicyComponent,
  ],
    imports: [
        BrowserModule,
        SharedModule,
        AppRoutingModule,
        AppBreadcrumbModule,
        BrowserAnimationsModule,
        AuthenticationModule.forRoot(),
        AppHeaderModule,
    ],
  providers: [],
  entryComponents: [
    CustomerAddComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
